import React from 'react';
import { Result } from 'antd';
import { imagePath } from '@common/services/images-service';
import { Colors, FontSize } from '@common/tokens';

export const ErrorMessageTemplate = ({
  title,
  imageName,
  imageAlt,
  children,
}: {
  title: string;
  imageName: string;
  imageAlt: string;
  children?: React.ReactNode;
}) => (
  <Result
    className="error-handler"
    icon={
      <img
        className="error-handler__image"
        src={imagePath(`./errors/${imageName}.svg`)}
        alt={imageAlt}
      />
    }
    extra={
      <>
        <main className="error-handler__content">
          <h1 className="error-handler__title">{title}</h1>
          <p className="error-handler__message">{children}</p>
        </main>

        <style jsx>{`
          .error-handler__image {
            width: 300px;
          }
          .error-handler__content,
          .error-handler__title {
            color: ${Colors.midnightLighter};
          }
          .error-handler__title {
            font-weight: bold;
            font-size: ${FontSize.xxxl};
          }
          .error-handler__message {
            font-size: ${FontSize.xl};
            line-height: 27px;
          }
        `}</style>
      </>
    }
  />
);
